// extracted by mini-css-extract-plugin
module.exports = {"section":"TestComponent_section__vhwqY"};